import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DsyListElement } from '../../../../../models/dsy-list-element.model';
import { DATE_PICKER_OPTIONS, DateOption } from '../../../../../models/filters.model';
import { ProgramOrganizationType } from '../../../../../models/program-organization.model';
import { FiltersStore } from '../../../../../store/signal-stores/pd-filters.signal-store';
import { DatePickerComponent } from '../../../../shared/components/date-picker/date-picker.component';
import { SearchableDropdownComponent } from '../../../../shared/components/searchable-dropdown/searchable-dropdown.component';

@Component({
  selector: 'fdr-past-performance-ui-organization-filters-panel',
  imports: [TranslateModule, DatePickerComponent, SearchableDropdownComponent],
  templateUrl: './organization-filters-panel.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  host: { style: 'display: contents' },
})
export class OrganizationFiltersPanelComponent {
  readonly store = inject(FiltersStore);

  readonly organizationEntries = input.required<DsyListElement[]>();
  readonly sitesEntries = input.required<DsyListElement[]>();
  readonly hasSelectedOrganization = input.required<boolean>();
  readonly showSitesCounterTag = input.required<boolean>();
  readonly dateResetToken = input.required<number>();
  readonly dropdownListConfig = { maxHeight: '300px' };
  readonly counterTagConfig = { variant: 'secondary' };
  readonly dateValidityChange = output<boolean>();

  readonly datesOptions = DATE_PICKER_OPTIONS;

  onDateChange(values: Date[]) {
    this.store.updateDateRange(ProgramOrganizationType.Organization, DateOption.customPeriod, values[0], values[1]);
  }

  onSuggestionChange(option: DateOption) {
    this.store.updateDateRange(ProgramOrganizationType.Organization, option);
  }

  onDateValidityChange(isValid: boolean) {
    this.dateValidityChange.emit(isValid);
  }
}
